// extracted by mini-css-extract-plugin
export default {"column":"Column_column__UyEvl","label":"Column_label__1zVrE","content":"Column_content__SU-2T"};